export default {
  data() {
    return {
      optionsSizes: {
        0: "col-auto",
        1: "col-12",
        2: "col-6",
        3: "col-4",
        4: "col-3",
        5: "col",
        6: "col-2",
      },
    };
  },
};
